import { ref, watch } from 'vue';
import { useDisplay } from 'vuetify';

const isCollapsedNavigation = ref(false);

export const useLayoutStore = () => {
  const display = useDisplay();

  const setIsCollapsedNavigation = (status: boolean) => {
    isCollapsedNavigation.value = status;
  };

  setIsCollapsedNavigation(display.lg.value);

  watch(
    () => display.lg.value,
    (newValue) => {
      setIsCollapsedNavigation(newValue);
    },
  );

  return {
    isCollapsedNavigation,

    setIsCollapsedNavigation,
  };
};
